import { useNavigate, useLocation } from "react-router-dom";
import { Home, Dumbbell, Brain, Bot, TrendingUp } from "lucide-react";

const TABS = [
  { id: "home", label: "Home", icon: Home, route: "/student" },
  { id: "practice", label: "Practice", icon: Dumbbell, route: "/courses" },
  { id: "brain-gym", label: "Brain Gym", icon: Brain, route: "/brain-gym" },
  { id: "mathbot", label: "MathBot", icon: Bot, route: "/ai-tutor" },
  { id: "progress", label: "Progress", icon: TrendingUp, route: "/analytics" },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t-2 border-slate-200 px-2 py-1.5 md:hidden flex justify-around items-center shadow-[0_-4px_20px_rgba(0,0,0,0.06)]"
      data-testid="student-bottom-nav"
    >
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const active = location.pathname === tab.route;
        return (
          <button
            key={tab.id}
            onClick={() => navigate(tab.route)}
            data-testid={`bottom-nav-${tab.id}`}
            className={`flex flex-col items-center justify-center gap-0.5 min-w-[56px] min-h-[52px] rounded-2xl px-2 py-1 transition-all ${
              active ? "text-indigo-600" : "text-slate-400 hover:text-slate-600"
            }`}
          >
            <div className={`flex items-center justify-center w-9 h-9 rounded-xl transition-all ${active ? "bg-indigo-100 scale-105" : ""}`}>
              <Icon className="w-5 h-5" strokeWidth={active ? 2.6 : 2.1} />
            </div>
            <span className={`text-[10px] font-['Lexend'] ${active ? "font-bold" : "font-medium"}`}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export function ProgressRing({ percent = 0, size = 128, stroke = 12, color = "#5B50E5", bg = "#E0E7FF", children, ...rest }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (Math.min(percent, 100) / 100) * circ;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} {...rest}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={bg} strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.8s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">{children}</div>
    </div>
  );
}
